import styled, { css } from 'styled-components'

import img from '../../assets/Images/landingImg.png'

export const FirstSection = styled.div`
  background: url(${img});
  background-repeat: no-repeat;
  background-size: cover;
  height: 660px;
  width: 100%;
`
export const FirstItems = styled.div`
  align-items: left;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 0 0 0 80px;
`

export const SecondSection = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 0;
  width: 100%;
`
export const SlideCard = styled.div`
  align-items: center;
  display: flex !important;
  flex-direction: column;
  height: 280px;
  justify-content: center;
  width: 100%;
`

export const BrandsCard = styled.div`
  align-items: center;
  display: flex !important;
  flex-direction: column;
  height: 150px;
  justify-content: center;
  width: 100%;
`
export const PillarItem = styled.div`
  ${({ width }) => css`
    align-items: left;
    display: flex !important;
    flex-direction: column;
    height: 280px;
    justify-content: center;
    padding: 30px;
    width: ${width ? width : ''};

    img {
      max-width: 54px;
    }
  `}
`

export const ItemHeader = styled.div`
  align-items: center;
  display: flex;

  img {
    width: 20px;
  }
`

export const ThirdSection = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 20px 80px;
  width: 100%;
`
export const ThirdSectionItem = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 80px;
`

export const FourthSection = styled.div`
  align-items: center;
  background-image: linear-gradient(#000, #171719);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 100px 0 0 0;
  padding: 40px 80px;
`
export const FifthSection = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 100px 0;
  padding: 40px 80px;
`

export const SliderBorder = styled.div`
  ${({ bottom }) => css`
    background: linear-gradient(
      90deg,
      rgba(192, 204, 218, 0.1) 0%,
      rgba(192, 204, 218, 0.6) 50.38%,
      rgba(192, 204, 218, 0.1) 100%
    );
    height: 1px;
    margin-top: ${bottom ? '-15px' : 0};
  `}
`
